import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DocumentSearchResult } from '../../document/models/documentSearchResult';
import { ApiConstants } from '../../shared/constants/api-constants';

@Injectable({
  providedIn: 'root'
})
export class MyClientSignaturesService {

  constructor(private httpClient: HttpClient) { }

  getMyClientSignatures(includeAll: boolean): Observable<DocumentSearchResult[]> {
    return this.httpClient.get<DocumentSearchResult[]>(ApiConstants.MyClientSignatures_Api+includeAll);
  }
}
